<template>
  <div>
    <div id="works" ref="works">
      <navigator-work
        label="ABOUT | CONTACT"
        section="ABOUT"
        previous_section="Home"
        previous_url="/"
      />
    </div>
    <div class="about-content">
      <div class="contact">
        <div class="contact-item">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="mailto:gabriela.claveria@gmail.com"
            >ladraaaaa@gmail.com
          </a>
        </div>
        <div class="contact-item">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.instagram.com/ladraaaaa"
            >@ladraaaaa
          </a>
        </div>
        <div class="contact-item">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://soundcloud.com/ladraaaaa"
            >soundcloud/ladraaaaa
          </a>
        </div>
      </div>
    </div>
    <!-- <DraggableDiv
      alt="alt"
      image_="media/uploads/about/AX2A5303.jpg"
      @index_="1"
    /> -->
    <div class="content">
      <div id="left-information">
        <p
          v-for="(paragraph, index) in paragraphs"
          :key="index"
          :ref="'paragraph_' + index"
          class="container-text"
        >
          <em class="title-text">{{ paragraph.title }}</em
          ><vue-marked class="p-text">{{
            paragraph[get_paragraphs()]
          }}</vue-marked>
        </p>
      </div>

      <div id="right-information">
        <div id="top-navigation">
          <div id="sections-container">
            <div
              v-for="(paragraph, index) in paragraphs"
              :key="index"
              class="section-text"
              @click="scroll_to(index)"
              v-html="formatTitle(paragraph.title)"
            >
            </div>
          </div>
          <div id="language-text">
            <button @click="update_language()" class="lang-button">{{ another_lang }}</button>
          </div>
        </div>
        <img
          v-if="aboutImage"
          class="image"
          :src="aboutImage"
          alt="About image"
        />
        <p v-if="aboutImage && showProfileImageCredits && profileImageCredits" id="image-description">
          {{ profileImageCredits }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import NavigatorWork from "@/components/NavigatorWork.vue";
import axios from "axios";
import VueMarked from "vue-marked";

export default {
  name: "About",
  components: { NavigatorWork, VueMarked },
  data: function () {
    return {
      profile_picture: "",
      paragraphs: "",
      actual_lang: "ESP",
      another_lang: "ENG",
      isMobile: false,
      aboutImage: "",
      showProfileImageCredits: false,
      profileImageCredits: "",
    };
  },
  methods: {
    resolve_img_url: function (path) {
      if (path === "") {
        return "";
      }
      let images = require.context(
        "../assets/photophone/images/",
        false,
        /\.png$|\.jpg$|\.gif/
      );
      return images(`./${path}`);
    },
    getData: async function () {
      try {
        axios
          .get("https://api.ladraaaaa.com/api/paragraph/")
          .then((response) => (this.paragraphs = response.data));
      } catch (error) {
        console.log(error);
      }
    },
    getAboutData: async function () {
      try {
        const response = await axios.get("https://api.ladraaaaa.com/api/about/");
        if (response.data.profile_image) {
          this.aboutImage = response.data.profile_image;
        }
        this.showProfileImageCredits = !!response.data.show_profile_image_credits;
        this.profileImageCredits = response.data.profile_image_credits || "";
      } catch (error) {
        console.log(error);
      }
    },
    get_paragraphs: function () {
      if (this.actual_lang == "ESP") {
        return "spanish_content";
      } else {
        return "english_content";
      }
    },
    update_language: function () {
      if (this.actual_lang == "ESP") {
        this.actual_lang = "ENG";
        this.another_lang = "ESP";
      } else {
        this.actual_lang = "ESP";
        this.another_lang = "ENG";
      }
    },
    scroll_to: function (id_paragraph) {
      var paragraph = "paragraph_" + id_paragraph;
      this.$refs[paragraph][0].scrollIntoView({ behavior: "smooth" });
    },
    formatTitle: function(title) {
      if (this.isMobile) {
        return title.replace(/([✧✦]+)/g, '<br>$1');
      }
      return title;
    },
    checkMobile: function() {
      this.isMobile = window.innerWidth < 768;
    },
    updateLinks: function() {
      this.$nextTick(() => {
        const leftInfo = document.querySelector('#left-information');
        if (leftInfo) {
          const links = leftInfo.querySelectorAll('a');
          links.forEach(link => {
            if (!link.hasAttribute('target')) {
              link.setAttribute('target', '_blank');
              link.setAttribute('rel', 'noopener noreferrer');
            }
          });
        }
      });
    },
  },
  created() {
    this.getData();
    this.getAboutData();
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
  },
  mounted() {
    this.updateLinks();
  },
  updated() {
    this.updateLinks();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile);
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Paprika&display=swap");

/* Base (mobile-first) */
body {
  background-color: #b1b2b5;
  font-family: "Paprika", regular, serif;
  margin: 24px;
}

a {
  color: #03ff00;
  text-decoration: none;
}

a:hover {
  color: blue;
}

.about-content {
  padding-top: 40px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  margin-right: 0;
}

.content {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding-top: 30px;
}

#left-information,
#right-information {
  width: 100%;
  margin-left: 0;
  margin-right: 0;
  background-color: transparent;
}

#left-information {
  display: flex;
  flex-direction: column;
}

p {
  text-align: justify;
  margin-block-start: 0;
}

#right-information {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  order: -1;
  margin-bottom: 1rem;
}

#top-navigation {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 35px;
}

#sections-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 1rem;
}

#language-text {
  color: #03ff00;
  margin-bottom: 0;
  font-size: 17px;
  font-family: "Paprika", regular, serif;
}

.lang-button {
  background-color: #c0c0c0;
  color: #03ff00;
  border: 2px solid;
  border-color: #ffffff #808080 #808080 #ffffff;
  padding: 4px 16px;
  font-size: 17px;
  font-family: "Paprika", regular, serif;
  cursor: pointer;
  box-shadow: inset 1px 1px 0 #dfdfdf, inset -1px -1px 0 #000000;
}

.lang-button:active {
  border-color: #808080 #ffffff #ffffff #808080;
  box-shadow: inset -1px -1px 0 #dfdfdf, inset 1px 1px 0 #000000;
  padding: 5px 15px 3px 17px;
}

.lang-button:hover {
  color: blue;
}

.section-text {
  color: #03ff00;
  font-size: 16px;
  font-family: "Paprika", regular, serif;
  display: inline-block;
  text-align: center;
}

.section-text:hover {
  cursor: pointer;
  color: blue;
}

.title-text {
  color: #03ff00;
  font-size: 20px;
  margin-bottom: 1rem;
}

.container-text {
  text-align: left;
  margin-bottom: 13px;
  font-family: "Paprika", regular, serif;
  font-size: 1rem;
}

.p-text {
  font-size: 18px;
  text-align: left;
  color: #2c3e50;
}

.contact {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 24px;
  margin-right: 0;
}

.contact-item {
  font-size: 20px;
  font-family: "Paprika", regular, serif;
}

.image {
  display: none;
  margin-top: 6rem;
}

#image-description {
  display: none;
  margin-top: 5px;
  color: #03ff00;
}

@media (min-width: 768px) {
  .about-content {
    padding-top: 60px;
    margin-right: 30px;
  }
  .content {
    padding-top: 40px;
  }
  .contact {
    flex-direction: row;
    justify-content: space-evenly;
  }
  .container-text,
  .section-text,
  #language-text {
    font-size: 1.2rem;
  }
  .lang-button {
    font-size: 1.2rem;
  }
}

@media (min-width: 1024px) {
  .about-content {
    padding-top: 80px;
    margin-right: 60px;
  }
  .content {
    flex-direction: row;
    padding-top: 50px;
  }
  .contact-item {
    font-size: 24px;
  }
  #left-information {
    width: 70%;
    margin-left: 30px;
  }
  #right-information {
    width: 30%;
    margin-left: 30px;
    order: 0;
    margin-bottom: 0;
  }
  #top-navigation {
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 0;
  }
  #sections-container {
    flex-direction: column;
    align-items: flex-start;
    gap: 0;
  }
  #language-text {
    margin-bottom: 35px;
  }
  .section-text {
    text-align: left;
    white-space: normal;
  }
  .section-text,
  #language-text {
    font-size: 1.5rem;
    display: block;
  }
  .lang-button {
    font-size: 1.5rem;
    margin-top: 20px;
  }
  .image {
    display: block;
  }
  #image-description {
    display: block;
  }
}

@media (min-width: 1280px) {
  .about-content {
    margin-top: 66px;
  }
  .content {
    padding-top: 70px;
  }
  #left-information {
    width: 1400px;
    margin-left: 80px;
  }
  #right-information {
    width: 300px;
    margin-left: 70px;
  }
  .container-text {
    font-size: 1.5rem;
  }
  .p-text {
    font-size: 26px;
  }
  .contact {
    margin-right: 200px;
  }
}
</style>
